import { ChildrenAnimalMotifProps } from '@ahc-digital/component-library';
import { C46ChildrensAnimalMotifProps } from './C46ChildrensAnimalMotif.types';
import { Image as JSSImage, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

const animalKeys = [
  ['FirstAnimalimage', 'FirstAnimalQuote'],
  ['SecondAnimalImage', 'SecondAnimalQuote'],
  ['ThirdAnimalImage', 'ThirdAnimalQuote'],
  ['FourthAnimalImage', 'FourthAnimalQuote'],
  ['FifthAnimalImage', 'FifthAnimalQuote'],
] as const;

export function CreateChildrensAnimalMotif(
  props?: C46ChildrensAnimalMotifProps
): ChildrenAnimalMotifProps {
  const { fields } = props || {};
  const { renderText, shouldRender } = useConditionalRendering();

  const renderLazyImage = (field?: ImageField) =>
    shouldRender(field?.value?.src) ? <JSSImage field={field} loading="lazy" /> : undefined;

  const animals = animalKeys.map(([imageKey, quoteKey]) => ({
    image: renderLazyImage(fields?.[imageKey]),
    quote: renderText(fields?.[quoteKey]),
  }));

  const staticMobileImage = renderLazyImage(fields?.StaticMobileImage);

  return {
    staticMobileImage,
    animals,
  };
}
